import Icon, { IconName } from "Components/Icons/Icon";
import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import { Label, Popover, PopoverBody } from "reactstrap";

export interface StatsCardProps {
  title: string;
  value?: number;
  icon: IconName;
  prefix: string;
  suffix: string;
  separator?: string;
  decimal?: number;
  showInitialBorder?: boolean;
  showLastBorderRadius?: boolean;
  isTooltip?: boolean;
  tooltipMessage?: string;
  status?: string;
  popoverId?: string;
}

const StatsCard = ({
  title,
  value,
  icon,
  prefix,
  suffix,
  separator,
  decimal,
  showInitialBorder,
  showLastBorderRadius,
  isTooltip,
  tooltipMessage,
  status,
  popoverId,
}: StatsCardProps) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const prevValueRef = useRef(value);

  useEffect(() => {
    prevValueRef.current = value;
  }, [value]);

  return (
    <div
      className={`flex-grow-1 p-3 d-flex flex-column justify-content-center w-100 ${
        showInitialBorder && "br-tl-10 br-bl-10"
      } ${showLastBorderRadius && "br-tr-10 br-br-10"}`}
    >
      <div className="d-flex gap-1 align-content-center flex-row">
        <Label className="font-primary fw-medium fs-14 text-grey89">
          {title}
          {isTooltip && (
            <>
              <i
                className="ri-error-warning-line text-grey89 ms-1 btn-press-effect"
                style={{ fontSize: 18 }}
                onClick={() => {
                  setShowTooltip((prev) => !prev);
                }}
                id={popoverId}
              />
              <Popover
                placement="auto"
                isOpen={showTooltip}
                target={popoverId ?? ""}
                toggle={() => {
                  setShowTooltip((prev) => !prev);
                }}
                trigger="legacy"
                popperClassName="br-10 p-2"
                innerClassName="p-0 m-0"
              >
                <PopoverBody className="bg-white font-primary fs-16 fw-normal text-black2D ">
                  {tooltipMessage}
                </PopoverBody>
              </Popover>
            </>
          )}
        </Label>
      </div>

      <div className="d-flex align-items-center gap-2 mt-2">
        <Icon name={icon} />
        <h4 className="fx-medium mb-0 d-flex">
          {value !== undefined ? (
            <CountUp
              start={prevValueRef.current}
              prefix={prefix}
              suffix={suffix}
              separator={separator || ""}
              end={value}
              decimals={decimal}
              duration={2}
              className="text-black2D fs-24 fw-semibold font-primary"
            />
          ) : (
            <span className="fs-24 fw-semibold font-primary text-black2D">
              {status}
            </span>
          )}
        </h4>
      </div>
    </div>
  );
};

export default StatsCard;
